export enum PlanTypes {
    GET_PLANS_REQUEST = ' GET_PLANS_REQUEST',
    GET_PLANS_SUCCESS = ' GET_PLANS_SUCCESS',
    GET_PLANS_ERROR = ' GET_PLANS_ERROR',

    GET_FAQS_REQUEST = ' GET_FAQS_REQUEST',
    GET_FAQS_SUCCESS = ' GET_FAQS_SUCCESS',
    GET_FAQS_ERROR = ' GET_FAQS_ERROR',

    CHANGE_PASSWORD_REQUEST = ' CHANGE_PASSWORD_REQUEST',
    CHANGE_PASSWORD_SUCCESS = ' CHANGE_PASSWORD_SUCCESS',
    CHANGE_PASSWORD_ERROR = ' CHANGE_PASSWORD_ERROR',

    UPDATE_PROFILE_REQUEST = ' UPDATE_PROFILE_REQUEST',
    UPDATE_PROFILE_SUCCESS = ' UPDATE_PROFILE_SUCCESS',
    UPDATE_PROFILE_ERROR = ' UPDATE_PROFILE_ERROR',

    POST_NOK_REQUEST = ' POST_NOK_REQUEST',
    POST_NOK_SUCCESS = ' POST_NOK_SUCCESS',
    POST_NOK_ERROR = ' POST_NOK_ERROR',

    GET_NOK_REQUEST = ' GET_NOK_REQUEST',
    GET_NOK_SUCCESS = ' GET_NOK_SUCCESS',
    GET_NOK_ERROR = ' GET_NOK_ERROR',

    RESET_PIN_REQUEST = ' RESET_PIN_REQUEST',
    RESET_PIN_SUCCESS = ' RESET_PIN_SUCCESS',
    RESET_PIN_ERROR = ' RESET_PIN_ERROR',

    UPDATE_AVATAR_REQUEST = ' UPDATE_AVATAR_REQUEST',
    UPDATE_AVATAR_SUCCESS = ' UPDATE_AVATAR_SUCCESS',
    UPDATE_AVATAR_ERROR = ' UPDATE_AVATAR_ERROR',

  }
  
  export interface PlanState {
    email?: string
    loading?: boolean
    isAuthenticated?: boolean
    access_token?: string
    error?: string
    phone_number?: string
  }
  
  export interface getPlansAction {
    type:
      | PlanTypes.GET_PLANS_REQUEST
      | PlanTypes.GET_PLANS_SUCCESS
      | PlanTypes.GET_PLANS_ERROR
    payload: PlanState 
  }
  export interface getFaqssAction {
    type:
      | PlanTypes.GET_FAQS_REQUEST
      | PlanTypes.GET_FAQS_SUCCESS
      | PlanTypes.GET_FAQS_ERROR
    payload: PlanState 
  }
  export interface changePasswordAction {
    type:
      | PlanTypes.CHANGE_PASSWORD_REQUEST
      | PlanTypes.CHANGE_PASSWORD_SUCCESS
      | PlanTypes.CHANGE_PASSWORD_ERROR
    payload: PlanState 
  }
  export interface updateProfileAction {
    type:
      | PlanTypes.UPDATE_PROFILE_REQUEST
      | PlanTypes.UPDATE_PROFILE_SUCCESS
      | PlanTypes.UPDATE_PROFILE_ERROR
    payload: PlanState 
  }
  export interface resetPinAction {
    type:
      | PlanTypes.RESET_PIN_REQUEST
      | PlanTypes.RESET_PIN_SUCCESS
      | PlanTypes.RESET_PIN_ERROR
    payload: PlanState 
  }
  export interface getNextOfKinAction {
    type:
      | PlanTypes.GET_NOK_REQUEST
      | PlanTypes.GET_NOK_SUCCESS
      | PlanTypes.GET_NOK_ERROR
    payload: PlanState 
  }
  export interface postNextOfKinAction {
    type:
      | PlanTypes.POST_NOK_REQUEST
      | PlanTypes.POST_NOK_SUCCESS
      | PlanTypes.POST_NOK_ERROR
    payload: PlanState 
  }
  export interface updateAvatarAction {
    type:
      | PlanTypes.UPDATE_AVATAR_REQUEST
      | PlanTypes.UPDATE_AVATAR_SUCCESS
      | PlanTypes.UPDATE_AVATAR_ERROR
    payload: PlanState 
  }
  export type PlanAction =
    | getPlansAction | getFaqssAction | changePasswordAction | updateProfileAction | resetPinAction |getNextOfKinAction | postNextOfKinAction | updateAvatarAction
  
  